export const USER_ROLES_QUERY = 'USER_ROLES_QUERY';
